export default __webpack_public_path__ + "static/media/CafeAvion-8.be00b3fe.jpg";